// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unified-tester-container {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    border: 1px solid rgba(255,255,255,0.1);
}

.unified-video-element {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.unified-player-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, transparent 100%);
    z-index: 10;
    pointer-events: none;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.player-badge {
    background: #e50914;
    color: white;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.player-title {
    color: white;
    font-size: 14px;
    font-weight: 500;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

.unified-player-error {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #1a1a1a;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ff4d4d;
    border-radius: 12px;
    text-align: center;
    padding: 20px;
}

/* Customizing default video controls style if browser allows */
video::-webkit-media-controls-panel {
    background-image: linear-gradient(transparent, rgba(0,0,0,0.8)) !important;
}

video::-webkit-media-controls-play-button {
    filter: invert(1);
}
`, "",{"version":3,"sources":["webpack://./src/AdvertiserPortal/Components/UnifiedTesterPlayer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;IACvC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,4EAA4E;IAC5E,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,+DAA+D;AAC/D;IACI,0EAA0E;AAC9E;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".unified-tester-container {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.5);\n    border: 1px solid rgba(255,255,255,0.1);\n}\n\n.unified-video-element {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.unified-player-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding: 20px;\n    background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, transparent 100%);\n    z-index: 10;\n    pointer-events: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.player-badge {\n    background: #e50914;\n    color: white;\n    padding: 4px 12px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.player-title {\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    text-shadow: 0 2px 4px rgba(0,0,0,0.5);\n}\n\n.unified-player-error {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    background: #1a1a1a;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #ff4d4d;\n    border-radius: 12px;\n    text-align: center;\n    padding: 20px;\n}\n\n/* Customizing default video controls style if browser allows */\nvideo::-webkit-media-controls-panel {\n    background-image: linear-gradient(transparent, rgba(0,0,0,0.8)) !important;\n}\n\nvideo::-webkit-media-controls-play-button {\n    filter: invert(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
